export default "__VITE_ASSET__BK8uQxq6__"